import React from "react";
import { Table } from "react-bootstrap";

const NewScopeTable = ({ data, sortConfig, onSortChange }) => {
  const renderSortIcon = (column) => {
    if (sortConfig?.key !== column) {
      return "";
    }

    return sortConfig.direction === "asc" ? " ▲" : " ▼";
  };

  return (
    <Table striped bordered hover>
      <thead>
        <tr>
          <th
            style={{ cursor: "pointer" }}
            onClick={() => onSortChange("SourceType")}
          >
            Przedział
            {renderSortIcon("SourceType")}
          </th>

          <th
            style={{ cursor: "pointer" }}
            onClick={() => onSortChange("CreatedAt")}
          >
            Data i czas dokonania zmiany
            {renderSortIcon("CreatedAt")}
          </th>

          <th
            style={{ cursor: "pointer" }}
            onClick={() => onSortChange("PlannedDate")}
          >
            Planowana data zmiany
            {renderSortIcon("PlannedDate")}
          </th>

          <th
            style={{ cursor: "pointer" }}
            onClick={() => onSortChange("CreatedByName")}
          >
            Osoba dokonująca zmiany
            {renderSortIcon("CreatedByName")}
          </th>

          <th
            style={{ cursor: "pointer" }}
            onClick={() => onSortChange("FromMinutes")}
          >
            Od [min]
            {renderSortIcon("FromMinutes")}
          </th>

          <th
            style={{ cursor: "pointer" }}
            onClick={() => onSortChange("ToMinutes")}
          >
            Do [min]
            {renderSortIcon("ToMinutes")}
          </th>
        </tr>
      </thead>
      <tbody>
        {data?.length ? (
          data.map((scope) => (
            <tr key={scope.id}>
              <td>
                {scope.sourceType === 1
                  ? "Średnia"
                  : scope.sourceType === 2
                    ? "Mediana"
                    : "-"}
              </td>

              <td>
                {scope.createdAt
                  ? new Date(scope.createdAt).toLocaleString("pl-PL")
                  : ""}
              </td>

              <td>
                {scope.plannedDate
                  ? new Date(scope.plannedDate).toLocaleDateString("pl-PL")
                  : ""}
              </td>
              <td>{scope.createdByName || "-"}</td>
              <td>{scope.fromMinutes}</td>
              <td>{scope.toMinutes}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="5" className="text-center">
              Brak danych
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export default NewScopeTable;
